export enum WebStoragesKeys {
  VENUE_DATA = 'venueData',
  API_CONFIG = 'apiConfig',
  FFLAGS = 'fflags',
  FUNNEL_JOURNEY_ID = 'funnelJourneyId',
  FUNNEL_BEACON_DEDUPE = 'funnelBeaconDedupe',
}
